import React from "react";
import PaymentMethodOption from "components/PaymentMethodOption";
import { useFormikContext } from "formik";
import { FORM_KEY } from "utils/constants/form";
import { SHIPPING_REQUIRED_PAYMENT_METHODS } from "utils/constants/payment";
import { getShippingConfig } from "utils/shortLink";
import MultiSelect from "components/Form/fields/MultiSelect";
import { getFieldPath } from "utils/form";
import get from "lodash/get";

const PaymentMethodSelect = ({ name, selections, options }) => {
  const {
    setFieldValue,
    setFieldTouched,
    touched,
    values
  } = useFormikContext();

  const shipping = getShippingConfig(values);
  const paymentMethodsPath = getFieldPath(name, "payment_method_types");
  const shippingWorldwidePath = getFieldPath(name, "shipping_worldwide");
  const formShippingAdrPath = `${FORM_KEY}.shipping_address_collection`;
  const paymentMethodsValue = get(values, paymentMethodsPath) || [];

  const selectProps = {
    value: selections,
    placeholder: "Select your payment methods",
    options,
    onChange: () => (updatedSelections) => {
      const selectedMethods = updatedSelections
        ? updatedSelections.map((selection) => selection.value)
        : [];

      if (!get(touched, paymentMethodsPath)) {
        setFieldTouched(paymentMethodsPath, true);
      }

      /**
       * Payment methods that require shipping
       * - So if transitioning to having Afterpay / Clearpay
       * - We auto set worldwide shipping so that the shipping validation doesnt fire straight away
       */
      for (
        let methodIx = 0;
        methodIx < SHIPPING_REQUIRED_PAYMENT_METHODS.length;
        methodIx++
      ) {
        const paymentMethod = SHIPPING_REQUIRED_PAYMENT_METHODS[methodIx];

        const haveMethod = paymentMethodsValue.indexOf(paymentMethod) > -1;
        const selectedMethod = selectedMethods.indexOf(paymentMethod) > -1;
        const gettingMethod = !haveMethod && selectedMethod;

        if (gettingMethod && !shipping.enabled) {
          setTimeout(() => setFieldValue(formShippingAdrPath, true), 0);
          setTimeout(() => setFieldValue(shippingWorldwidePath, true), 0);
          break;
        }
      }

      setTimeout(() => setFieldValue(paymentMethodsPath, selectedMethods), 0);
    },
    labelTransform: (value) => value,
    components: {
      Option: PaymentMethodOption
    }
  };

  return <MultiSelect {...selectProps} />;
};

export default PaymentMethodSelect;
